import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FAQSection from '@/components/feature/FAQSection';
import { useCMS } from '@/hooks/useCMS';

const DEFAULT = {
  hero_label: 'ჩვენი ისტორია',
  hero_heading: 'ჩვენ შესახებ',
  hero_subtext: '25 წელი საქართველოს სამშენებლო ინდუსტრიის მშენებლობაში პრემიუმ მასალებითა და ხარისხისადმი ურყევი ვალდებულებით.',
  hero_image: 'https://readdy.ai/api/search-image?query=elegant%20modern%20corporate%20office%20interior%20with%20premium%20stone%20flooring%20and%20sophisticated%20design%2C%20professional%20business%20environment%2C%20warm%20ambient%20lighting%2C%20minimalist%20architecture%2C%20warm%20neutral%20tones%2C%20beige%20and%20cream%20background&width=1600&height=420&seq=abouthero&orientation=landscape',
  hero_image_alt: 'Phoenix Georgia-ს შესახებ',
  breadcrumb_home: 'მთავარი',
  breadcrumb_current: 'ჩვენ შესახებ',
  mission_label: 'ვინ ვართ',
  mission_heading: 'საქართველოს ყველაზე სანდო\nსამშენებლო პარტნიორი',
  mission_body1: '1999 წელს თბილისში დაარსებული, Phoenix-მა ორ ათწლეულზე მეტი გაატარა საქართველოში პრემიუმ სამშენებლო მასალების ყველაზე სანდო მომწოდებლის რეპუტაციის შესაქმნელად. მცირე საიმპორტო ბიზნესიდან გაიზარდა 50-ზე მეტი სპეციალისტის მქონე კომპანიამდე, რომელიც ემსახურება ასობით კლიენტს მთელი ქვეყნის მასშტაბით.',
  mission_body2: 'ვართ საქართველოში ზოგიერთი ყველაზე პრესტიჟული სამშენებლო მასალების ბრენდის ექსკლუზიური ავტორიზებული დისტრიბუტორი — Laminam (იტალია), Antolini (იტალია), Ardex (გერმანია), Tecnopol, Dicson და Fodbo.',
  mission_body3: 'ჩვენი მისია მარტივია: მოვიტანოთ მსოფლიო დონის სამშენებლო მასალები და ექსპერტული ცოდნა საქართველოში ყოველ პროექტზე.',
  mission_image: 'https://readdy.ai/api/search-image?query=premium%20construction%20materials%20showroom%20in%20Tbilisi%20Georgia%20with%20elegant%20stone%20and%20tile%20displays%2C%20professional%20lighting%2C%20modern%20minimalist%20design%20space%2C%20warm%20neutral%20tones%2C%20high-end%20material%20samples%20beautifully%20arranged%2C%20clean%20white%20and%20beige%20background&width=700&height=480&seq=about2&orientation=portrait',
  mission_image_alt: 'Phoenix Georgia შოურუმის ინტერიერი',
  mission_stats: [{ value: '25+', label: 'წელი' }, { value: '5,000+', label: 'პროექტი' }, { value: '50+', label: 'ექსპერტი' }, { value: '6', label: 'ბრენდი' }],
  values_label: 'რა გვამოძრავებს',
  values_heading: 'ჩვენი ძირითადი ღირებულებები',
  values: [
    { icon: 'ri-medal-line',       title: 'ხარისხი პირველ ადგილზე', desc: 'ჩვენ არასოდეს ვთმობთ ხარისხს. ყველა პროდუქტი, რომელსაც ვამარაგებთ, და ყველა სერვისი, რომელსაც ვაწვდით, აკმაყოფილებს საერთაშორისო სტანდარტებს.' },
    { icon: 'ri-shake-hands-line', title: 'სანდო პარტნიორობა',      desc: 'ჩვენი ურთიერთობები მსოფლიო წამყვან ბრენდებთან დაფუძნებულია ურთიერთნდობასა და სრულყოფილებისადმი ერთობლივ ვალდებულებაზე.' },
    { icon: 'ri-lightbulb-line',   title: 'ინოვაცია',               desc: 'ჩვენ მუდმივად ვეძებთ უახლეს მასალებსა და ტექნოლოგიებს, რათა კლიენტებს შევთავაზოთ ინოვაციური გადაწყვეტილებები.' },
    { icon: 'ri-heart-line',       title: 'კლიენტზე ორიენტაცია',  desc: 'ყოველი გადაწყვეტილება, რომელსაც ვიღებთ, ხელმძღვანელობს კლიენტის ინტერესებით. თქვენი წარმატება ჩვენი წარმატებაა.' },
  ],
  milestones_label: 'ჩვენი გზა',
  milestones_heading: 'სრულყოფილების 25 წელი',
  milestones: [
    { year: '1999', title: 'Phoenix-ის დაარსება',               desc: 'კომპანია დაარსდა თბილისში, საქართველოში, ვიზიით — მოეტანა პრემიუმ სამშენებლო მასალები ქართულ ბაზარზე.' },
    { year: '2003', title: 'პირველი საერთაშორისო პარტნიორობა', desc: 'მოვიპოვეთ Tecnopol-ის ჰიდროიზოლაციის სისტემების ექსკლუზიური დისტრიბუციის უფლება.' },
    { year: '2008', title: 'Laminam-ის პარტნიორობა',            desc: 'გავხდით Laminam-ის ექსკლუზიური ქართველი დისტრიბუტორი — იტალიის წამყვანი ულტრა-თხელი კერამიკის მწარმოებლის.' },
    { year: '2012', title: 'Antolini და Ardex',                  desc: 'გავაფართოვეთ პრემიუმ პორტფოლიო Antolini-ს ბუნებრივი ქვისა და Ardex-ის სამშენებლო მასალების ექსკლუზიური პარტნიორობით.' },
    { year: '2018', title: 'ახალი შოურუმის გახსნა',             desc: 'გავხსენით ჩვენი ფლაგმანური შოურუმი თბილისში, სადაც წარმოდგენილია საქართველოში პრემიუმ სამშენებლო მასალების ყველაზე დიდი ექსპოზიცია.' },
    { year: '2024', title: 'სრულყოფილების 25 წელი',            desc: 'ვზეიმობთ 25 წელს საქართველოს სამშენებლო ინდუსტრიის მომსახურებაში — 5,000-ზე მეტი დასრულებული პროექტი.' },
  ],
  team_label: 'Phoenix-ის უკან მყოფი ადამიანები',
  team_heading: 'გაიცანით ჩვენი ხელმძღვანელობა',
  team_subtext: 'ჩვენი გამოცდილი პროფესიონალების გუნდი ერთგულია ყოველი კლიენტისთვის განსაკუთრებული შედეგების მიწოდებისა.',
  team: [
    { name: 'გიორგი ბერიძე',   role: 'გენერალური დირექტორი და დამფუძნებელი', desc: '25-წლიანი გამოცდილებით სამშენებლო მასალების ინდუსტრიაში, გიორგიმ დააარსა Phoenix ვიზიით — მოეტანა მსოფლიო დონის მასალები საქართველოში.', image: 'https://readdy.ai/api/search-image?query=professional%20Georgian%20male%20business%20executive%20in%20his%2050s%2C%20confident%20smile%2C%20wearing%20a%20dark%20suit%2C%20modern%20office%20background%2C%20warm%20neutral%20tones%2C%20professional%20headshot%20style%2C%20clean%20beige%20background&width=400&height=400&seq=team1&orientation=squarish' },
    { name: 'ნინო კვარაცხელია', role: 'ინტერიერის დიზაინის ხელმძღვანელი',    desc: 'თბილისის სახელმწიფო სამხატვრო აკადემიის კურსდამთავრებული, ნინო ხელმძღვანელობს ჩვენს დიზაინის კონსულტაციის გუნდს 15-წლიანი გამოცდილებით.',  image: 'https://readdy.ai/api/search-image?query=professional%20Georgian%20female%20interior%20designer%20in%20her%2040s%2C%20warm%20confident%20smile%2C%20smart%20casual%20attire%2C%20modern%20design%20studio%20background%2C%20warm%20neutral%20tones%2C%20professional%20headshot%20style%2C%20clean%20beige%20background&width=400&height=400&seq=team2&orientation=squarish' },
    { name: 'დავით ლომიძე',    role: 'ტექნიკური დირექტორი',                  desc: 'დავითი ზედამხედველობს ყველა ტექნიკურ ოპერაციასა და მონტაჟის ხარისხს, რაც უზრუნველყოფს ყოველი პროექტის ჩვენი მაღალი სტანდარტების შესაბამისობას.', image: 'https://readdy.ai/api/search-image?query=professional%20Georgian%20male%20engineer%20in%20his%2040s%2C%20professional%20smile%2C%20wearing%20business%20casual%20attire%2C%20modern%20office%20background%2C%20warm%20neutral%20tones%2C%20professional%20headshot%20style%2C%20clean%20beige%20background&width=400&height=400&seq=team3&orientation=squarish' },
    { name: 'თამარ ჯიქია',     role: 'გაყიდვები და კლიენტებთან ურთიერთობა', desc: 'თამარი მართავს ჩვენს მთავარ კლიენტებთან ურთიერთობებს და უზრუნველყოფს, რომ ყოველი კლიენტი მიიღებს პერსონალიზებულ ყურადღებასა და ექსპერტულ კონსულტაციას.', image: 'https://readdy.ai/api/search-image?query=professional%20Georgian%20female%20business%20executive%20in%20her%2030s%2C%20friendly%20professional%20smile%2C%20smart%20business%20attire%2C%20modern%20office%20background%2C%20warm%20neutral%20tones%2C%20professional%20headshot%20style%2C%20clean%20beige%20background&width=400&height=400&seq=team4&orientation=squarish' },
  ],
  location_label: 'მოგვინახულეთ',
  location_heading: 'ჩვენი შოურუმი თბილისში',
  location_body: 'ეწვიეთ ჩვენს ფლაგმანურ შოურუმს თბილისში, რათა პირადად გაეცნოთ ჩვენი პრემიუმ სამშენებლო მასალების სრულ კოლექციას.',
  location_address: 'გელოვანის ქ. N13, თბილისი, საქართველო',
  location_phone: '+995 599 87 20 20 / 0322 570 505',
  location_hours: 'ორშაბათი – შაბათი: 9:30 – 19:30',
  location_btn_label: 'შოურუმის ვიზიტის დაჯავშნა',
  location_map_embed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2978.5!2d44.8015!3d41.6938!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDQxJzM3LjciTiA0NMKwNDgnMDUuNCJF!5e0!3m2!1ska!2sge!4v1234567890',
  faq_label: 'ხშირად დასმული კითხვები',
  faq_title: 'კომპანიის შესახებ კითხვები',
  faq_subtitle: 'ყველაფერი, რაც უნდა იცოდეთ Phoenix-ის შესახებ. სხვა კითხვის შემთხვევაში, გთხოვთ პირდაპირ დაგვიკავშირდეთ.',
  faq_items: [
    { question: 'როდის დაარსდა Phoenix?',                                              answer: 'Phoenix დაარსდა 1999 წელს თბილისში, საქართველოში. 25 წელზე მეტი ხნის განმავლობაში ვართ საქართველოს სამშენებლო ინდუსტრიის სანდო პარტნიორი.' },
    { question: 'რამდენი თანამშრომელი ჰყავს Phoenix-ს?',                              answer: 'Phoenix-ს ჰყავს 50-ზე მეტი გამოცდილი სპეციალისტი, მათ შორის არქიტექტორები, ინჟინრები, ინტერიერის დიზაინერები და ტექნიკური ექსპერტები.' },
    { question: 'რომელი ბრენდების ექსკლუზიური დისტრიბუტორია Phoenix საქართველოში?',  answer: 'Phoenix არის ექსკლუზიური ავტორიზებული დისტრიბუტორი: Laminam (იტალია), Antolini (იტალია), Ardex (გერმანია), Tecnopol, Dicson და Fodbo.' },
    { question: 'სად შემიძლია Phoenix-ის შოურუმის მონახულება?',                       answer: 'ჩვენი ფლაგმანური შოურუმი მდებარეობს თბილისში, გელოვანის ქ. N13-ზე. ვმუშაობთ ორშაბათიდან შაბათამდე, 9:30-დან 19:30-მდე.' },
    { question: 'მუშაობს თუ არა Phoenix მხოლოდ საქართველოში?',                       answer: 'ჩვენი ძირითადი ოპერაციები ორიენტირებულია საქართველოზე. ჩვენი საერთაშორისო ბრენდ-პარტნიორობები გვაძლევს საშუალებას მოვიტანოთ გლობალური ხარისხი ადგილობრივ ბაზარზე.' },
  ],
  cta_heading: 'ერთად ავაშენოთ რაღაც განსაკუთრებული',
  cta_subtext: 'იქნება ეს არქიტექტორი, დიზაინერი თუ დეველოპერი — გვაქვს მასალები, ექსპერტიზა და გატაცება, რათა თქვენი ვიზია რეალობად ვაქციოთ.',
  cta_btn_services_label: 'ჩვენი სერვისების გაცნობა',
  cta_btn_services_href: '/services',
  cta_btn_call_label: 'დაგვიკავშირდით დღეს',
  cta_btn_call_href: 'tel:+995599872020',
};

function AnimatedSection({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.1 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} style={{ opacity: visible ? 1 : 0, transform: visible ? 'translateY(0)' : 'translateY(25px)', transition: `opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms` }}>
      {children}
    </div>
  );
}

export default function AboutPage() {
  const cms = useCMS('about_page', DEFAULT);

  const missionStats: typeof DEFAULT.mission_stats = cms.mission_stats ?? DEFAULT.mission_stats;
  const values: typeof DEFAULT.values = cms.values ?? DEFAULT.values;
  const milestones: typeof DEFAULT.milestones = cms.milestones ?? DEFAULT.milestones;
  const team: typeof DEFAULT.team = cms.team ?? DEFAULT.team;
  const faqItems: typeof DEFAULT.faq_items = cms.faq_items ?? DEFAULT.faq_items;
  const faqs = faqItems.map((item) => ({ question: item.question, answer: item.answer }));

  return (
    <div className="font-sans bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative h-[340px] md:h-[420px] overflow-hidden">
        <img src={cms.hero_image} alt={cms.hero_image_alt} className="w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
        <div className="absolute inset-0 flex items-center justify-center flex-col text-center px-6">
          <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 bg-brand-rust/10 border border-brand-rust/30 px-3 py-1 rounded-full">{cms.hero_label}</span>
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4">{cms.hero_heading}</h1>
          <p className="text-white/80 text-sm md:text-base max-w-xl leading-relaxed">{cms.hero_subtext}</p>
          <div className="flex items-center gap-2 mt-4 text-white/60 text-xs">
            <Link to="/" className="hover:text-white transition-colors cursor-pointer">{cms.breadcrumb_home}</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">{cms.breadcrumb_current}</span>
          </div>
        </div>
      </section>

      {/* Mission */}
      <section className="py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <AnimatedSection>
              <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 block">{cms.mission_label}</span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark leading-tight mb-6">{cms.mission_heading}</h2>
              <p className="text-brand-gray text-sm leading-relaxed mb-5">{cms.mission_body1}</p>
              <p className="text-brand-gray text-sm leading-relaxed mb-5">{cms.mission_body2}</p>
              <p className="text-brand-gray text-sm leading-relaxed mb-8">{cms.mission_body3}</p>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                {missionStats.map((stat) => (
                  <div key={stat.label} className="text-center p-4 bg-brand-warm rounded-lg">
                    <div className="font-serif text-2xl font-bold text-brand-rust">{stat.value}</div>
                    <div className="text-xs text-brand-gray mt-1">{stat.label}</div>
                  </div>
                ))}
              </div>
            </AnimatedSection>
            <AnimatedSection delay={200}>
              <div className="relative w-full h-[480px] rounded-lg overflow-hidden">
                <img src={cms.mission_image} alt={cms.mission_image_alt} className="w-full h-full object-cover object-top" />
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 md:py-24 bg-brand-warm">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <AnimatedSection>
            <div className="text-center mb-14">
              <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 block">{cms.values_label}</span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark">{cms.values_heading}</h2>
            </div>
          </AnimatedSection>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((v, i) => (
              <AnimatedSection key={v.title} delay={i * 100}>
                <div className="bg-white rounded-lg p-7 border border-gray-100 h-full">
                  <div className="w-12 h-12 flex items-center justify-center bg-brand-rust/10 rounded-lg mb-5">
                    <i className={`${v.icon} text-brand-rust text-xl`}></i>
                  </div>
                  <h3 className="font-semibold text-brand-dark text-base mb-3">{v.title}</h3>
                  <p className="text-sm text-brand-gray leading-relaxed">{v.desc}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <AnimatedSection>
            <div className="text-center mb-14">
              <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 block">{cms.milestones_label}</span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark">{cms.milestones_heading}</h2>
            </div>
          </AnimatedSection>
          <div className="relative">
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-px bg-gray-200 -translate-x-1/2"></div>
            <div className="flex flex-col gap-8">
              {milestones.map((m, i) => (
                <AnimatedSection key={m.year} delay={i * 80}>
                  <div className={`flex flex-col md:flex-row items-start md:items-center gap-6 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                      <div className="bg-brand-warm rounded-lg p-6 border border-gray-100 inline-block w-full md:max-w-sm">
                        <div className="text-brand-rust font-bold text-sm mb-1">{m.year}</div>
                        <h3 className="font-semibold text-brand-dark text-base mb-2">{m.title}</h3>
                        <p className="text-xs text-brand-gray leading-relaxed">{m.desc}</p>
                      </div>
                    </div>
                    <div className="hidden md:flex w-10 h-10 flex-shrink-0 items-center justify-center bg-brand-rust rounded-full z-10">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                    <div className="flex-1 hidden md:block"></div>
                  </div>
                </AnimatedSection>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 md:py-28 bg-brand-warm">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <AnimatedSection>
            <div className="text-center mb-14">
              <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 block">{cms.team_label}</span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark">{cms.team_heading}</h2>
              <p className="text-brand-gray text-sm mt-4 max-w-xl mx-auto leading-relaxed">{cms.team_subtext}</p>
            </div>
          </AnimatedSection>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {team.map((member, i) => (
              <AnimatedSection key={member.name} delay={i * 100}>
                <div className="bg-white rounded-lg overflow-hidden border border-gray-100 group">
                  <div className="w-full h-56 overflow-hidden">
                    <img src={member.image} alt={`${member.name} - ${member.role}`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  </div>
                  <div className="p-5">
                    <h3 className="font-semibold text-brand-dark text-base">{member.name}</h3>
                    <div className="text-brand-rust text-xs font-medium mt-0.5 mb-3">{member.role}</div>
                    <p className="text-xs text-brand-gray leading-relaxed">{member.desc}</p>
                  </div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Location */}
      <section className="py-20 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
            <AnimatedSection>
              <span className="text-brand-rust text-xs font-semibold tracking-[0.2em] uppercase mb-3 block">{cms.location_label}</span>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark mb-6">{cms.location_heading}</h2>
              <p className="text-brand-gray text-sm leading-relaxed mb-8">{cms.location_body}</p>
              <div className="flex flex-col gap-4 mb-8">
                {[
                  { icon: 'ri-map-pin-line', text: cms.location_address },
                  { icon: 'ri-phone-line',   text: cms.location_phone },
                  { icon: 'ri-time-line',    text: cms.location_hours },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center bg-brand-rust/10 rounded-lg flex-shrink-0">
                      <i className={`${item.icon} text-brand-rust`}></i>
                    </div>
                    <span className="text-sm text-brand-charcoal">{item.text}</span>
                  </div>
                ))}
              </div>
              <Link to="/" className="inline-flex items-center gap-2 bg-brand-rust text-white font-semibold px-6 py-3 rounded-md hover:bg-[#b36a4b] transition-colors duration-200 text-sm cursor-pointer whitespace-nowrap">
                {cms.location_btn_label} <i className="ri-arrow-right-line"></i>
              </Link>
            </AnimatedSection>
            <AnimatedSection delay={200}>
              <div className="w-full h-[380px] rounded-lg overflow-hidden border border-gray-100">
                <iframe src={cms.location_map_embed} width="100%" height="100%" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Phoenix Georgia მდებარეობა"></iframe>
              </div>
            </AnimatedSection>
          </div>
        </div>
      </section>

      <FAQSection faqs={faqs} label={cms.faq_label} title={cms.faq_title} subtitle={cms.faq_subtitle} />

      {/* CTA */}
      <section className="bg-brand-dark py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-white mb-4">{cms.cta_heading}</h2>
          <p className="text-white/60 text-sm max-w-xl mx-auto mb-8 leading-relaxed">{cms.cta_subtext}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to={cms.cta_btn_services_href} className="bg-brand-rust text-white font-semibold px-7 py-3.5 rounded-md hover:bg-[#b36a4b] transition-colors duration-200 text-sm cursor-pointer whitespace-nowrap">
              {cms.cta_btn_services_label}
            </Link>
            <a href={cms.cta_btn_call_href} className="border border-white/30 text-white font-semibold px-7 py-3.5 rounded-md hover:bg-white/10 transition-colors duration-200 text-sm cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line mr-2"></i>{cms.cta_btn_call_label}
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
